import { motion } from 'motion/react';
import { useEffect } from 'react';

import { VFlex } from '../VFlex';
import { CheckCircle, Close, Error, Info, Warning } from '../asset';
import { joinCn } from '../util';
import { TOAST_VARIANT } from './constant';
import { useVToast } from './hook';
import twStyle from './style';
import type { VToastProps } from './type';

const VToastItem = ({ toast }: VToastProps) => {
  const { variant, autoClose } = toast;
  const { removeToast } = useVToast();
  const style = twStyle({ toast });

  const Icon = (() => {
    let Icon = <Info className={joinCn(style.icon, 'text-info-500')} />;

    switch (variant) {
      case TOAST_VARIANT.ERROR:
        Icon = <Error className={joinCn(style.icon, 'text-error-500')} />;
        break;
      case TOAST_VARIANT.SUCCESS:
        Icon = (
          <CheckCircle className={joinCn(style.icon, 'text-success-500')} />
        );
        break;
      case TOAST_VARIANT.WARNING:
        Icon = <Warning className={joinCn(style.icon, 'text-warning-500')} />;
        break;
    }

    return Icon;
  })();

  useEffect(() => {
    if (autoClose) {
      setTimeout(() => {
        removeToast(toast.id);
      }, toast.duration ?? 3000);
    }
  }, [autoClose, removeToast, toast.id, toast.duration]);

  return (
    <motion.div
      initial={{ opacity: 0, x: 300, scale: 0.3 }}
      animate={{ opacity: 1, x: 0, scale: 1 }}
      exit={{ opacity: 0, x: 300, scale: 0.5 }}
      transition={{
        duration: 0.3,
      }}
    >
      <VFlex className={style.baseItem} items="center" gap={0.5}>
        {Icon}
        <span>{toast.message}</span>
        {!autoClose && (
          <Close
            role="button"
            className={joinCn(style.icon, 'mt-[0.5px] text-gray-400')}
            onClick={() => removeToast(toast.id)}
          />
        )}
      </VFlex>
    </motion.div>
  );
};

export default VToastItem;
